module.exports = __webpack_public_path__ + "img/bookings.46f4a82c.svg";